import HttpClient from './HttpClient';

const OrdenPagoService = {
  documentos: (images) => {
    const path = 'orden/pdf';
    return HttpClient.post(path, images, true, true);
  },
  orders: (params) => {
    const path = 'orden';
    return HttpClient.get(path, params, true, true);
  },
  asignar: (params) => {
    const path = 'orden/asignar';
    return HttpClient.post(path, params, true, true);
  }
};

export default OrdenPagoService;
